import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";

const TabComponent = ({ tabArray, activeKey, onTabSelect }) => {
  const validKeys = tabArray.map(tab => tab.key);
  useEffect(()=>{
      const initialKey = activeKey === undefined
      ? validKeys[0]
      : validKeys.includes(activeKey)
        ? activeKey
        : null;
        setKey(initialKey)
  },[activeKey])

  const [key, setKey] = useState();

  return (
    <>
      <Tabs
        id="controlled-hospi-cash-tab"
        activeKey={key}
        onSelect={(k) => {
          setKey(k);
          onTabSelect(k);
        }}
        className="mb-3 claim-processing-tabs"
      >
        {tabArray?.map((tab) => (
          <Tab eventKey={tab.key} title={tab.title} key={tab.key}>
            {tab?.child && tab?.child}
          </Tab>
        ))}
      </Tabs>
    </>
  );
};

export default TabComponent;
